import SEOMetadata from '@/components/SEOMetadata';
import React, { Suspense } from 'react';
import StyledPrivacy from './styles/PrivacyPageStyles';
import { useIdlePrefetch } from '@/hooks/useIdlePrefetch';

const loadFooter = () => import('@/components/landing/Footer');
const Footer = React.lazy(loadFooter);

const TermsPage: React.FC = () => {
  useIdlePrefetch([loadFooter]);
  return (
    <>
      <SEOMetadata
        title="Terms of Service – AxionQuant"
        description="AxionQuant's terms of service governing your use of our financial data API platform."
        canonicalUrl="https://axionquant.com/terms"
      />
      <StyledPrivacy>
        <div className="hero">
          <div className="content">
            <h1 className="serif">Terms of Service</h1>
          </div>
        </div>

        <article className="privacy-content">

          <h2 className="first" data-tab-order="3">1. Terms</h2>

          <p data-tab-order="4">By accessing the website at <a href="https://axionquant.com">https://axionquant.com</a>, you are agreeing to be bound by these terms of service, all applicable laws and regulations, and agree that you are responsible for compliance with any applicable local laws. If you do not agree with any of these terms, you are prohibited from using or accessing this site. The materials contained in this website are protected by applicable copyright and trademark law.</p>

          <h2 data-tab-order="5">2. Use License</h2>

          <ol type="a">
            <li data-tab-order="6">
              Permission is granted to temporarily download one copy of the materials (information or software) on Axion's website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:

              <ol type="i">
                <li data-tab-order="7">modify or copy the materials;</li>
                <li data-tab-order="8">use the materials for any commercial purpose, or for any public display (commercial or non-commercial);</li>
                <li data-tab-order="9">attempt to decompile or reverse engineer any software contained on Axion's website;</li>
                <li data-tab-order="10">remove any copyright or other proprietary notations from the materials; or</li>
                <li data-tab-order="11">transfer the materials to another person or "mirror" the materials on any other server.</li>
              </ol>
            </li>
            <li data-tab-order="12">This license shall automatically terminate if you violate any of these restrictions and may be terminated by Axion at any time. Upon terminating your viewing of these materials or upon the termination of this license, you must destroy any downloaded materials in your possession whether in electronic or printed format.</li>
          </ol>

          <h2 data-tab-order="13">3. Disclaimer</h2>

          <ol type="a">
            <li data-tab-order="14">The materials on Axion's website are provided on an 'as is' basis. Axion makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.</li>
            <li data-tab-order="15">Further, Axion does not warrant or make any representations concerning the accuracy, likely results, or reliability of the use of the materials on its website or otherwise relating to such materials or on any sites linked to this site.</li>
          </ol>

          <h2 data-tab-order="16">4. Limitations</h2>

          <p data-tab-order="17">In no event shall Axion or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on Axion's website, even if Axion or a Axion authorized representative has been notified orally or in writing of the possibility of such damage. Because some jurisdictions do not allow limitations on implied warranties, or limitations of liability for consequential or incidental damages, these limitations may not apply to you.</p>

          <h2 data-tab-order="18">5. Accuracy of materials</h2>

          <p data-tab-order="19">The materials appearing on Axion website could include technical, typographical, or photographic errors. Axion does not warrant that any of the materials on its website are accurate, complete or current. Axion may make changes to the materials contained on its website at any time without notice. However Axion does not make any commitment to update the materials.</p>

          <h2 data-tab-order="20">6. Links</h2>

          <p data-tab-order="21">Axion has not reviewed all of the sites linked to its website and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by Axion of the site. Use of any such linked website is at the user's own risk.</p>

          <h2 data-tab-order="22">7. Modifications</h2>

          <p data-tab-order="23">Axion may revise these terms of service for its website at any time without notice. By using this website you are agreeing to be bound by the then current version of these terms of service.</p>

          <h2 data-tab-order="24">8. Governing Law</h2>

          <p data-tab-order="25">These terms and conditions are governed by and construed in accordance with the laws of Toronto ON and you irrevocably submit to the exclusive jurisdiction of the courts in that State or location.</p>
        </article>



        <Suspense fallback={null}>
        <Footer />
        </Suspense>
      </StyledPrivacy>
    </>
  );
};

export default TermsPage;

